import { useAuthxAuthorizationPageController } from "./AuthxAuthorizationPage.controller";
import { AuthxAuthorizationPagePresentation } from "./AuthxAuthorizationPage.pres";

export const AuthxAuthorizationPage = () => {
  const controller = useAuthxAuthorizationPageController();

  return <AuthxAuthorizationPagePresentation {...controller} />;
};
